/** @jsxImportSource @emotion/react */
import { CSSObject, jsx } from '@emotion/react';
import { gridSize } from '../theme/constants';
import { colors } from '../theme';
import { headingSizes } from '../theme/typography';

const itemDescriptionSpacing = gridSize() * 0;
const itemTopBottomPadding = gridSize();
const itemSidePadding = gridSize() * 2.5;

export const itemCSS = {
  // padding: `${itemTopBottomPadding}px ${itemSidePadding}px`,
};

export const contentCSS = {
  flexGrow: 1,
  textAlign: 'left',
  overflow: 'hidden',
  outline: 'none',
  display: 'flex',
  flexDirection: 'column',
  color: colors.heading(),
  // lineHeight: 1.2,
} as CSSObject;

export const truncateCSS = {
  display: 'block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
} as CSSObject;

export const descriptionCSS = {
  ...truncateCSS,
  color: colors.subtleText(),
  marginTop: itemDescriptionSpacing,
  fontSize: headingSizes.h200.size,
} as CSSObject;

interface OptionProps {
  children?: React.ReactNode;
  description?: React.ReactNode;
}

const Option = ({ children, description }: OptionProps) => (
  <div css={itemCSS}>
    <div css={contentCSS}>{children}</div>
    <div css={descriptionCSS}>{description}</div>
  </div>
);

export default Option;
